const pi = 3.14159265358979324;
const a = 6378245.0;
// 参考椭球体 Krasovsky 1940
// a = 6378245.0, 1/f = 298.3
// b = a * (1 - f)
// ee = (a^2 - b^2) / a^2;
const ee = 0.00669342162296594323;
const x_pi = 3.14159265358979324 * 3000.0 / 180.0;

/**
 * 国标转百度
 * @param y
 * @param x
 * @returns {*[]}
 */
const gcj2bd = (y, x) => {
  var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);

  var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
  var bd_lon = z * Math.cos(theta) + 0.0065;
  var bd_lat = z * Math.sin(theta) + 0.006;
  return [bd_lat, bd_lon];
}

/**
 * 百度转国标
 * @param y
 * @param x
 * @returns {*[]}
 */
const bd2gcj = (y, x) => {
  x = x - 0.0065, y = y - 0.006;

  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);

  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
  var x = z * Math.cos(theta)
  var y = z * Math.sin(theta)
  return [y, x];
}

const outOfChina = (lat, lon) => {
  if (lon < 72.004 || lon > 137.8347)
    return true;
  if (lat < 0.8293 || lat > 55.8271)
    return true;
  return false;
}

const transformLat = (x, y) => {
  var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(y * pi) + 40.0 * Math.sin(y / 3.0 * pi)) * 2.0 / 3.0;
  ret += (160.0 * Math.sin(y / 12.0 * pi) + 320 * Math.sin(y * pi / 30.0)) * 2.0 / 3.0;
  return ret;
}

const transformLon = (x, y) => {
  var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(x * pi) + 40.0 * Math.sin(x / 3.0 * pi)) * 2.0 / 3.0;
  ret += (150.0 * Math.sin(x / 12.0 * pi) + 300.0 * Math.sin(x / 30.0 * pi)) * 2.0 / 3.0;
  return ret;
}

export const wgs2gcj = (wgLon , wgLat) => {
  var mgLat, mgLon;
  if (outOfChina(wgLat, wgLon)) {
    mgLat = wgLat;
    mgLon = wgLon;
    return [mgLon , mgLat];
  }

  var dLat = transformLat(wgLon - 105.0, wgLat - 35.0),
    dLon = transformLon(wgLon - 105.0, wgLat - 35.0),
    radLat = wgLat / 180.0 * pi,
    magic = Math.sin(radLat);

  magic = 1 - ee * magic * magic;
  var sqrtMagic = Math.sqrt(magic);
  dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * pi);
  dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * pi);
  mgLat = wgLat + dLat;
  mgLon = wgLon + dLon;
  return [mgLon , mgLat];
}

// 二分法
export const gcj2wgs = (gcjLon, gcjLat) => {

  var initDelta = 0.01;
  var threshold = 1e-9;
  var dLat = initDelta, dLon = initDelta;
  var mLat = gcjLat - dLat, mLon = gcjLon - dLon;
  var pLat = gcjLat + dLat, pLon = gcjLon + dLon;
  var wgsLat, wgsLon, i = 0;
  while (1) {
      wgsLat = (mLat + pLat) / 2;
      wgsLon = (mLon + pLon) / 2;
      var tmp = wgs2gcj(wgsLon,wgsLat)
      dLat = tmp[1] - gcjLat;
      dLon = tmp[0] - gcjLon;
      if ((Math.abs(dLat) < threshold) && (Math.abs(dLon) < threshold))
          break;

      if (dLat > 0) pLat = wgsLat; else mLat = wgsLat;
      if (dLon > 0) pLon = wgsLon; else mLon = wgsLon;

      if (++i > 10000) break;
  }
  //console.log(i);
  return [wgsLon , wgsLat];
  /*
  let g0 = [gcjLon, gcjLat]
  let w0 = g0
  let g1 = wgs2gcj(w0[0], w0[1])
  # w1 = w0 - (g1 - g0)
  w1 = tuple(map(lambda x: x[0]-(x[1]-x[2]), zip(w0,g1,g0)))
  # delta = w1 - w0
  delta = tuple(map(lambda x: x[0] - x[1], zip(w1, w0)))
  while (abs(delta[0]) >= 1e-6 or abs(delta[1]) >= 1e-6):
      w0 = w1
      g1 = wgs2gcj(w0[0], w0[1])
      # w1 = w0 - (g1 - g0)
      w1 = tuple(map(lambda x: x[0]-(x[1]-x[2]), zip(w0,g1,g0)))
      # delta = w1 - w0
      delta = tuple(map(lambda x: x[0] - x[1], zip(w1, w0)))
  return w1
  */
}

export const wgs2gcjBatch = (arr) => {
  for (let d of arr) {
    if (d.lng && d.lat) {
      let conv = wgs2gcj(d.lng, d.lat)
      d.lng = conv[0]
      d.lat = conv[1]
    }
  }
}

export default { wgs2gcj , gcj2wgs }